import React, { useState } from "react";
import { MdRemoveCircleOutline, MdAddCircleOutline } from "react-icons/md";
import { questions } from "../../../data/FAQs";
import Footer from "../../shared/Footer";
import Newsletter from "../../shared/Newsletter";
const FAQs = () => {
  const [open, setOpen] = useState(null);
  return (
    <>
      <div className=" py-10">
        <div className="flex justify-center items-center gap-2 flex-col mb-10">
          <p className="text-primary text-sm font-semibold">FAQs</p>
          <h3 className="text-black lg:text-3xl text-2xl font-bold">
            We're here to help
          </h3>
          <p className="text-accent text-sm ">
            Have questions? We're here to help
          </p>
        </div>
        <div className="  bg-[rgb(249,250,251)] py-10 ">
          <div className="lg:w-[50%] md:w-[80%] w-[93%] mx-auto space-y-6 mb-10">
            <div className="text-center">
              <h3 className="lg:text-2xl text-xl font-bold text-black mb-1">
                Frequently asked questions
              </h3>
              <p className="text-accent text-sm">
                Everything you need to know about the product and billing
              </p>
            </div>
            <div className="">
              {questions.map((item, index) => (
                <div
                  key={index}
                  onClick={() => setOpen(index)}
                  onDoubleClick={() => setOpen(null)}
                  className="border-b border-b-gray-200 py-4 "
                >
                  <div className="flex justify-between items-center cursor-pointer ">
                    <h3 className="font-semibold text-lg">{item.title}</h3>
                    {open === index ? (
                      <MdRemoveCircleOutline className="text-primary text-xl" />
                    ) : (
                      <MdAddCircleOutline className="text-primary text-xl" />
                    )}
                  </div>
                  {open === index && (
                    <p className="text-sm text-accent mt-2 ">{item.text}</p>
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="py-5 text-center bg-white rounded-xl space-y-3 w-[80%] mx-auto">
            <div className="flex justify-center">
              <div className="avatar-group -space-x-5">
                <div className="avatar">
                  <div className="w-12">
                    <img src="https://placeimg.com/192/192/people" />
                  </div>
                </div>

                <div className="avatar z-50">
                  <div className="w-12">
                    <img src="https://placeimg.com/192/192/people" />
                  </div>
                </div>
                <div className="avatar">
                  <div className="w-12">
                    <img src="https://placeimg.com/192/192/people" />
                  </div>
                </div>
              </div>
            </div>
            <h3 className="font-semibold">Still have questions ?</h3>
            <p className="text-accent">
              Can't find the answer you're looking for? Please chat to our
              friendly team
            </p>
            <button className="btn btn-md btn-primary text-white">
              Get in touch
            </button>
          </div>
        </div>
      </div>
      <Newsletter />
      <Footer />
    </>
  );
};

export default FAQs;
